export enum CarouselType {
  ICONS = "ICONS",
  POPULAR_PRODUCTS = "POPULAR_PRODUCTS",
}

interface BaseAlgoliaCarouselFilters {
  carouselType: CarouselType;
  gender: string;
}

interface IconsAlgoliaCarouselFilters extends BaseAlgoliaCarouselFilters {
  carouselType: CarouselType.ICONS;
  brandSlug: string;
}

interface PopularProductsCarouselFilters extends BaseAlgoliaCarouselFilters {
  carouselType: CarouselType.POPULAR_PRODUCTS;
  brandSlug: string;
  gender?: string;
}

export type AlgoliaCarouselFilters =
  | IconsAlgoliaCarouselFilters
  | PopularProductsCarouselFilters;

export type IconsAlgoliaCarouselProps = IconsAlgoliaCarouselFilters & {
  labelsType: string;
};

export type PopularProductsCarouselProps = PopularProductsCarouselFilters;

export type AlgoliaCarouselsHookProps = (
  | IconsAlgoliaCarouselProps
  | PopularProductsCarouselProps
) & {
  hitsPerPage?: number;
  ruleContexts?: string[];
  enablePersonalization?: boolean;
  isDesignerBrand?: boolean;
  sortBy?: string;
};
